import { render } from "./FormBlocks.vue?vue&type=template&id=30249516"
import script from "./FormBlocks.vue?vue&type=script&lang=js"
export * from "./FormBlocks.vue?vue&type=script&lang=js"

import "./FormBlocks.vue?vue&type=style&index=0&id=30249516&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__